export * from '@fhs/routing/src/routes/v2/menu/(menu)/index';
export { default } from '@fhs/routing/src/routes/v2/menu/(menu)/index';
